<script lang="ts" setup>
import {
  callOnce,
  defineOgImageComponent,
  useHead,
  useLocalePath,
  usePlaces,
} from "#imports";
import MPSectionHeader from "~/components/layouts/MPSectionHeader.vue";

const localePath = useLocalePath();
const placesStore = usePlaces();

await callOnce(
  async () => {
    await placesStore.fetchTopPlaces({ limit: 50 });
  },
  { mode: "navigation" },
);

useHead(() => ({
  title: "Discover destinations",
  meta: [
    {
      name: "description",
      content: "Explore the world and discover new places to visit",
    },
  ],
}));

defineOgImageComponent("Default", {
  title: "Discover destinations",
  description: "Explore the world and discover new places to visit",
});
</script>

<template>
  <div class="destinations-page">
    <MPSectionHeader
      title="Destinations"
      subtitle="Explore your next destination"
      summary="Explore the world and discover new places to visit"
      size="large"
    />
    <div class="destinations-list">
      <div
        v-for="destination in placesStore.topPlaces"
        :key="destination.id"
        class="destinations-item"
        :style="`background-image: url(${destination.cover_image_url})`"
      >
        <NuxtLink :to="localePath(`/destinations/${destination.id}`)">
          <div class="destinations-item-content">
            <h5>{{ destination.place }}</h5>
            <small>{{ destination.regionCountry }}</small>
          </div>
        </NuxtLink>
      </div>
    </div>
  </div>
</template>

<style lang="postcss" scoped>
@import "@/assets/css/breakpoints.pcss";
@import "@/assets/css/layouts.pcss";

.destinations-page {
  @mixin layout-wrapper-wide;
  padding: 1rem 0;
  @mixin screen md {
    padding-top: 8rem;
  }
}

.destinations-list {
  display: grid;
  width: 100%;
  grid-template-columns: 1fr;
  gap: 1rem;
  /* padding: 0 1rem; */
  grid-auto-flow: dense;
  /* margin: 4rem auto; */
  padding: 1rem;
  @mixin screen sm {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-auto-flow: dense;
    > :nth-child(6n + 3),
    > :nth-child(8n + 5) {
      grid-column: span 2;
    }
  }
  @mixin screen md {
    display: grid;
    padding: 0;
    grid-template-columns: repeat(3, 1fr);
    grid-auto-flow: dense;
    > :nth-child(6n + 3),
    > :nth-child(8n + 5) {
      grid-column: span 2;
    }
  }
  @mixin screen lg {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-auto-flow: dense;
    > :nth-child(6n + 3),
    > :nth-child(8n + 5) {
      grid-column: span 2;
    }
  }
}
.destinations-item {
  height: 12rem;
  border-radius: 1rem;
  background-position: center;
  background-size: cover;
  color: var(--color-slate-50);
  background-color: var(--color-slate-500);
  @mixin screen sm {
    height: 18rem;
  }
}
.destinations-item-content {
  text-align: left;
  border-radius: 1rem;
  display: flex;
  flex-direction: column;
  align-items: bottom;
  padding: 1rem;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    -20deg,
    rgba(0, 0, 0, 0) 30%,
    rgba(0, 0, 0, 0.7) 100%
  );
  h5 {
    margin: 0;
  }
  small {
    color: var(--color-slate-200);
  }
}

.callout {
  display: grid;
  background-color: var(--color-green-500);
  background-color: var(--color-slate-100);
  color: var(--color-slate-900);
  border: 1px solid var(--color-slate-200);
  grid-column: 1 / span 1 !important;
  grid-row-start: 3;
  @mixin screen sm {
    grid-column: 2 / span 1 !important;
  }
  @mixin screen lg {
    grid-column: 4 / span 1 !important;
  }
  .destinations-item-content {
    justify-content: space-between;
    background-image: none;
    padding: 1.5rem;
    h5 {
      margin: 0;
    }
    p {
      color: var(--color-slate-500);
    }
  }
  /* .callout + .callout {
    grid-row-start: 12;
    @mixin screen lg {
      grid-row-start: 5;
      grid-column-start: 1;
    }
  } */
}
</style>
